import { useState} from 'react';
import { useSelector} from 'react-redux';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const ReaderApp = () => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [deleteReaderShow, setDeleteReaderShow] = useState(false);
    const [readerModalShow, setReaderModalShow] = useState(false);
    const [selectedList, setSelectedList] = useState(false);

    return {
        DEV,
        permission,
        deleteReaderShow,
        setDeleteReaderShow,
        readerModalShow,
        setReaderModalShow,
        selectedList,
        setSelectedList
    }

}

export default ReaderApp;
